// extracted by mini-css-extract-plugin
export default {"btn4":"simonButton_btn4__pSwyr","btn9":"simonButton_btn9__QjOUx"};